import { Attribute } from '../../../concepts/objects';
import { RoadmapCard } from './RoadmapCard';

export const RoadmapCardStartDate = new Attribute<Date, RoadmapCard>('roadmapCardStartDate', null);
export const RoadmapCardTargetDate = new Attribute<Date, RoadmapCard>('roadmapCardTargetDate', null);
export const RoadmapCardEndDate = new Attribute<Date, RoadmapCard>('roadmapCardEndDate', null);